module.exports = __webpack_public_path__ + "explore/Components/ExploreHeader/pocket-logo.fe803ab33bfe0272aea33040711caf9e.svg";